import { ActionIcon, Tooltip } from "@mantine/core";
import { IconRefreshDot } from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { getEmailTypeProps } from "../../sendersUtil";

const ReconnectEmail = ({ current, setTableLoading }) => {
  const [loading, setLoading] = useState(false);
  const handleReconnect = (e) => {
    e.stopPropagation();
    setLoading(true);
    getEmailTypeProps(current.account_type)
      .editFunction({
        id: current.id,
        data: {
          connection_test: true,
        },
      })
      .then(() => {
        setTableLoading(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (current?.auth_url) {
    return (
      <Tooltip label={"Reconnecter"}>
        <ActionIcon
          size="lg"
          ml={16}
          color="green"
          component={Link}
          to={current?.auth_url}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          radius={64}
        >
          <IconRefreshDot size={20} />
        </ActionIcon>
      </Tooltip>
    );
  }
  return (
    <Tooltip label={"Reconnecter"}>
      <ActionIcon
        size="lg"
        ml={16}
        color="green"
        onClick={handleReconnect}
        loading={loading}
        radius={64}
      >
        <IconRefreshDot size={20} />
      </ActionIcon>
    </Tooltip>
  );
};

export default ReconnectEmail;
